"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merchant = require("@/api/merchant");
var _customPage = _interopRequireDefault(require("@/components/customPage"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    customPage: _customPage.default
  },
  data: function data() {
    return {
      balance: 0,
      frozen: 0,
      tableData: [],
      total: 0
    };
  },
  methods: {
    goToRecharge: function goToRecharge() {
      var routeData = this.$router.resolve({
        name: "recharge"
      });
      window.open(routeData.href, '_blank');
    },
    getData: function getData() {
      var _this = this;
      (0, _merchant.myAccount)().then(function (res) {
        var balance = res.balance,
          frozen = res.frozen;
        _this.balance = balance;
        _this.frozen = frozen;
      });
    },
    // 获取数据
    getList: function getList() {
      var _this2 = this;
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      (0, _merchant.withdrawalList)({
        page: page,
        pageSize: pageSize,
        adminMobile: '',
        status: '',
        arrivalTime: ''
      }).then(function (res) {
        _this2.tableData = res.data || [];
        _this2.total = res.total || 0;
      });
    }
  },
  mounted: function mounted() {
    this.getData();
    this.getList();
  }
};
exports.default = _default;